export default class Common{
    static screen = []
    static token = ''
    static xAuth=''

}